// Enhanced cart URL opener with add-to-cart functionality
document.addEventListener('DOMContentLoaded', function() {
  const urlParams = new URLSearchParams(window.location.search);
  const addToCartParam = urlParams.get('add-to-cart');
  const replaceCartParam = urlParams.get('replace-cart');
  const cartParam = urlParams.get('cart');
  const openCartParam = urlParams.get('open-cart');
  const discountParams = urlParams.getAll('discount');

  // Apply discount codes first if present
  if (discountParams.length > 0) {
    console.log(`[Juno Bio] Discount codes detected in URL:`, discountParams);
    applyDiscountCodes(discountParams).then(() => {
      // After discount codes are applied, proceed with cart operations
      if (replaceCartParam) {
        handleReplaceCart(replaceCartParam, cartParam, openCartParam);
      } else if (addToCartParam) {
        handleAddToCart(addToCartParam, cartParam, openCartParam);
      } else if (shouldOpenCart(cartParam, openCartParam)) {
        openCartDrawer();
      }
    });
  } else {
    // No discount codes, proceed normally
    if (replaceCartParam) {
      handleReplaceCart(replaceCartParam, cartParam, openCartParam);
    } else if (addToCartParam) {
      handleAddToCart(addToCartParam, cartParam, openCartParam);
    } else if (shouldOpenCart(cartParam, openCartParam)) {
      openCartDrawer();
    }
  }
});

function applyDiscountCodes(discountCodes) {
  if (!discountCodes || discountCodes.length === 0) {
    return Promise.resolve();
  }

  console.log(`[Juno Bio] Applying ${discountCodes.length} discount code(s) using native Shopify method`);

  // Apply discount codes sequentially using Shopify's native /discount/[code] endpoint
  let promise = Promise.resolve();

  discountCodes.forEach(function(discountCode) {
    if (discountCode && discountCode.trim()) {
      promise = promise.then(function() {
        return applySingleDiscountCode(discountCode.trim());
      }).catch(function(error) {
        console.error(`[Juno Bio] Failed to apply discount code ${discountCode}:`, error);
        return Promise.resolve(); // Continue with next discount code
      });
    }
  });

  // After all discount codes are applied, force cart update to show discounts
  return promise.then(function() {
    console.log('[Juno Bio] All discount codes applied, refreshing cart drawer');
    return refreshCartDrawer();
  }).catch(function(error) {
    console.error('[Juno Bio] Failed to refresh cart after applying discounts:', error);
  });
}

function applySingleDiscountCode(discountCode) {
  return new Promise((resolve, reject) => {
    console.log(`[Juno Bio] Applying discount code: ${discountCode}`);

    // Save the discount code as a session cookie
    document.cookie = `discount_code=${discountCode}; path=/`;

    // Send GET request to "/discount/[discountcode]"
    fetch(`/discount/${discountCode}`)
      .then(response => {
        if (response.ok) {
          console.log(`[Juno Bio] Successfully applied discount code: ${discountCode}`);
          resolve();
        } else {
          console.warn(`[Juno Bio] Discount code ${discountCode} may not be valid or active`);
          resolve(); // Don't reject, just continue with other codes
        }
      })
      .catch(error => {
        console.error(`[Juno Bio] Error applying discount code ${discountCode}:`, error);
        resolve(); // Don't reject, just continue with other codes
      });
  });
}

function shouldOpenCart(cartParam, openCartParam) {
  return (
    cartParam === 'open' ||
    openCartParam === 'true' ||
    openCartParam === '1'
  );
}

function handleReplaceCart(replaceCartParam, cartParam, openCartParam) {
  // Parse multiple products separated by spaces
  const products = replaceCartParam.split(' ').filter(item => item.trim());

  if (products.length === 0) {
    console.warn('[Juno Bio] No valid products found in replace-cart parameter');
    return;
  }

  console.log(`[Juno Bio] Replacing cart with ${products.length} product(s)`);

  clearCart().then(() => {
    const addPromises = products.map(productString => {
      const [variantId, quantity = '1'] = productString.split(':');

      if (!variantId || !/^\d+$/.test(variantId)) {
        console.error(`[Juno Bio] Invalid variant ID: ${variantId}`);
        return Promise.resolve(null);
      }

      const qty = parseInt(quantity);
      if (isNaN(qty) || qty <= 0) {
        console.error(`[Juno Bio] Invalid quantity for variant ${variantId}: ${quantity}`);
        return Promise.resolve(null);
      }

      return addSingleProductToCart(variantId, qty);
    });

    Promise.all(addPromises).then(results => {
      const successfulAdds = results.filter(result => result !== null);

      if (successfulAdds.length > 0) {
        animateCartIcon();

        console.log(`[Juno Bio] Successfully replaced cart with ${successfulAdds.length} product(s)`);

        refreshCartDrawer().then(() => {
          if (shouldOpenCart(cartParam, openCartParam)) {
            setTimeout(() => {
              openCartDrawer();
            }, 200);
          }
        });
      } else {
        console.warn('[Juno Bio] No products were successfully added to cart after replacement.');
      }
    });
  }).catch(error => {
    console.error('[Juno Bio] Failed to clear cart before replacement:', error);
  });
}

function handleAddToCart(addToCartParam, cartParam, openCartParam) {
  const products = addToCartParam.split(' ').filter(item => item.trim());

  if (products.length === 0) {
    console.warn('[Juno Bio] No valid products found in add-to-cart parameter');
    return;
  }

  const addPromises = products.map(productString => {
    const [variantId, quantity = '1'] = productString.split(':');

    if (!variantId || !/^\d+$/.test(variantId)) {
      console.error(`[Juno Bio] Invalid variant ID: ${variantId}`);
      return Promise.resolve(null);
    }

    const qty = parseInt(quantity);
    if (isNaN(qty) || qty <= 0) {
      console.error(`[Juno Bio] Invalid quantity for variant ${variantId}: ${quantity}`);
      return Promise.resolve(null);
    }

    return addSingleProductToCart(variantId, qty);
  });

  Promise.all(addPromises).then(results => {
    const successfulAdds = results.filter(result => result !== null);

    if (successfulAdds.length > 0) {
      animateCartIcon();

      console.log(`[Juno Bio] Successfully added ${successfulAdds.length} product(s) to cart`);

      refreshCartDrawer().then(() => {
        if (shouldOpenCart(cartParam, openCartParam)) {
          setTimeout(() => {
            openCartDrawer();
          }, 200);
        }
      });
    } else {
      console.warn('[Juno Bio] No products were successfully added to cart.');
    }
  });
}

function clearCart() {
  return fetch('/cart/clear.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
    }
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('[Juno Bio] Cart cleared successfully');
    return data;
  })
  .catch(error => {
    console.error('[Juno Bio] Failed to clear cart:', error.message);
    throw error;
  });
}

function addSingleProductToCart(variantId, quantity) {
  const formData = new FormData();
  formData.append('id', variantId);
  formData.append('quantity', quantity);

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
    },
    body: formData
  })
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log(`[Juno Bio] Added variant ${variantId} (qty: ${quantity}) to cart:`, data);
    return data;
  })
  .catch(error => {
    console.error(`[Juno Bio] Failed to add variant ${variantId} to cart:`, error.message);

    // Handle specific Shopify errors
    if (error.message.includes('422')) {
      console.error(`[Juno Bio] Variant ${variantId} may be out of stock or invalid`);
    } else if (error.message.includes('404')) {
      console.error(`[Juno Bio] Variant ${variantId} not found`);
    }

    return null;
  });
}

function refreshCartDrawer() {
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
    cartDrawerItems.onCartUpdate();

    setTimeout(() => {
      updateCartDrawerEmptyState();
    }, 100);
  } else {
    fetch(`${window.routes.cart_url}?section_id=cart-drawer`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const selectors = ['cart-drawer-items', '.cart-drawer__footer'];

        for (const selector of selectors) {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        }

        updateCartDrawerEmptyState();
      })
      .catch((e) => {
        console.error('[Juno Bio] Failed to refresh cart drawer:', e);
      });
  }

  // Also update the cart icon
  fetch(`${window.routes.cart_url}?section_id=cart-icon-bubble`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const currentCartBubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
      const newCartBubble = html.querySelector('.cart-count-bubble');

      if (currentCartBubble && newCartBubble) {
        currentCartBubble.innerHTML = newCartBubble.innerHTML;
        console.log('[Juno Bio] Updated cart icon count');
      }
    })
    .catch((e) => {
      console.error('[Juno Bio] Failed to refresh cart icon:', e);
    });

  return Promise.resolve();
}

function updateCartDrawerEmptyState() {
  // Get current cart state to properly manage empty state
  fetch('/cart.js')
    .then(response => response.json())
    .then(cartData => {
      const cartDrawer = document.querySelector('cart-drawer');
      const emptyState = document.querySelector('.drawer__inner-empty');

      if (cartDrawer) {
        // Update cart drawer empty class
        cartDrawer.classList.toggle('is-empty', cartData.item_count === 0);

        // Hide/show empty state content
        if (emptyState) {
          emptyState.style.display = cartData.item_count === 0 ? 'block' : 'none';
        }

        console.log(`[Juno Bio] Updated cart drawer empty state: ${cartData.item_count} items`);
      }
    })
    .catch(error => {
      console.error('[Juno Bio] Failed to update cart drawer empty state:', error);
    });
}

function animateCartIcon() {
  const cartIcon = document.querySelector('#cart-icon-bubble');
  if (!cartIcon) {
    console.warn('[Juno Bio] Cart icon not found for animation.');
    return;
  }

  // Add bounce animation class
  cartIcon.style.transition = 'transform 0.3s ease-in-out';
  cartIcon.style.transform = 'scale(1.2)';

  // Reset after animation
  setTimeout(() => {
    cartIcon.style.transform = 'scale(1)';
  }, 300);

  // Add a subtle pulse effect
  cartIcon.style.animation = 'cart-pulse 0.6s ease-in-out';

  // Clean up animation
  setTimeout(() => {
    cartIcon.style.animation = '';
  }, 600);
}

function openCartDrawer() {
  const openCart = () => {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    } else {
      // Retry if cart drawer isn't ready yet
      setTimeout(openCart, 50);
    }
  };

  // Start the process after a short delay
  setTimeout(openCart, 100);
}

// Add CSS animation for cart pulse effect
const style = document.createElement('style');
style.textContent = `
  @keyframes cart-pulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.15); }
    100% { transform: scale(1); }
  }
`;
document.head.appendChild(style);